<template>
  <section class="skills">
    <heading :ahead="ahead" :behind="behind" />
    <div class="cover">
      <item
        v-for="(skill, i) in skills"
        :key="i"
        :image="skill.image"
        :about="skill.about"
      />
    </div>
  </section>
</template>

<script>
import Heading from "../components/Heading.vue";
import Item from "../components/Item.vue";

export default {
  name: "Skills",
  components: {
    Heading,
    Item
  },
  data() {
    return {
      ahead: "Professional",
      behind: "Skills",
      skills: [
        {
          image: "logos/angular.png",
          about: "Angular"
        },
        {
          image: "logos/java.png",
          about: "Java"
        },
        {
          image: "logos/materialUi.png",
          about: "Material Design"
        },
        {
          image: "logos/vue.png",
          about: "VueJs"
        },
        {
          image: "logos/javascript.png",
          about: "JavaScript"
        },
        {
          image: "logos/mongodb.png",
          about: "MongoDB"
        },
        {
          image: "logos/photoshop.png",
          about: "Photoshop"
        },
        {
          image: "logos/nodejs.png",
          about: "Node.js"
        },
        {
          image: "logos/springBoot.png",
          about: "Spring Boot"
        },
        {
          image: "logos/sqlServer.png",
          about: "SQL"
        }
      ]
    };
  }
};
</script>

<style scoped>
.skills {
  padding: 1em;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.cover {
  margin: 1em;
  padding: 1.5em;
  max-width: 1000px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
</style>
